module.exports = __webpack_public_path__ + "media/masterplan.a02cd3cd.png";